export function createEmitter<Events extends Record<string, unknown[]>>() {
  const handlers = new Map<keyof Events, Set<(...args: any[]) => void>>();
  return {
    on<K extends keyof Events>(ev: K, cb: (...args: Events[K]) => void) {
      if (!handlers.has(ev)) handlers.set(ev, new Set());
      handlers.get(ev)!.add(cb as any);
    },
    off<K extends keyof Events>(ev: K, cb: (...args: Events[K]) => void) {
      handlers.get(ev)?.delete(cb as any);
    },
    emit<K extends keyof Events>(ev: K, ...args: Events[K]) {
      handlers.get(ev)?.forEach((cb) => {
        try {
          cb(...args);
        } catch (e) {
          console.error('[sidekick] handler error', e);
        }
      });
    },
  };
}
